/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestimonialContent } from '../../models/testimonial-content';

export interface ApiMasterTestimonialContentGetAllGet$Params {
}

export function apiMasterTestimonialContentGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterTestimonialContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TestimonialContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTestimonialContentGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TestimonialContent>>;
    })
  );
}

apiMasterTestimonialContentGetAllGet.PATH = '/api/Master/TestimonialContent/GetAll';
